import type { SuspiciousCCActivityType } from "@daytrip/legacy-enums";

export class SuspiciousCCActivityIssue {
    type: SuspiciousCCActivityType;

    reason: string;

    constructor(init?: SuspiciousCCActivityIssue) {
        if (init) {
            Object.assign(this, init);
        }
    }
}
